import type React from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog"
import { ScrollArea } from "@/components/ui/scroll-area"

interface TermsOfServicePopupProps {
  isOpen: boolean
  onClose: () => void
}

const TermsOfServicePopup: React.FC<TermsOfServicePopupProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Terms of Service</DialogTitle>
          <DialogDescription>Last updated: February 2025</DialogDescription>
        </DialogHeader>
        <ScrollArea className="mt-4 max-h-[60vh] pr-4">
          <div className="space-y-4 text-sm">
            <p>
              Welcome to Coverage Maps! By using our platform, you agree to comply with and be bound by these Terms of
              Service.
            </p>

            <h3 className="font-semibold text-base">1. Acceptance of Terms</h3>
            <p>
              By accessing or using Coverage Maps, you agree to be bound by these terms and all applicable laws and
              regulations.
            </p>

            <h3 className="font-semibold text-base">2. Use License</h3>
            <ul className="list-disc pl-5 space-y-2">
              <li>You may use Coverage Maps for personal and business purposes</li>
              <li>You are responsible for maintaining the confidentiality of your data</li>
              <li>You agree not to misuse or abuse our services</li>
            </ul>

            <h3 className="font-semibold text-base">3. Service Availability</h3>
            <p>
              While we strive for 100% uptime, we cannot guarantee uninterrupted access to our services. We reserve the
              right to modify or discontinue services with or without notice.
            </p>

            <h3 className="font-semibold text-base">4. Data Usage</h3>
            <p>You retain all rights to your data. We may use anonymized data for improving our services.</p>

            <h3 className="font-semibold text-base">5. Disclaimer</h3>
            <p>Coverage Maps is provided "as is" without warranties of any kind, either express or implied.</p>

            <h3 className="font-semibold text-base">6. Contact</h3>
            <p>
              For questions about these Terms, please contact us at{" "}
              <a href="mailto:contact@coverage-maps.com" className="text-blue-600 hover:underline">
                contact@coverage-maps.com
              </a>
              .
            </p>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  )
}

export default TermsOfServicePopup
